import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AttachmentService, FakeData } from '../../core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'common-airline-schedule-popup',
  templateUrl: './airline-schedule-popup.component.html',
  styleUrl: './airline-schedule-popup.component.scss',
  standalone: false,
})
export class AirlineSchedulePopupComponent {
  @Input() row: FakeData;
  @Output() onDownload = new EventEmitter();
  scheduleUrl: any;
  airlineScheduleisplay: any[];
  files: any;
  constructor(
    public activeModal: NgbActiveModal,
    private readonly router: Router,
    private readonly attachmentService: AttachmentService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.files = [];
    if (this.row.airlineBrand?.scheduleAttachments) {
      this.files = this.row.airlineBrand.scheduleAttachments.map(
        (attachment: any) => ({
          name: attachment.fileName,
          type: attachment.fileType,
          size: attachment.fileSize,
          id: attachment.id,
        }),
      );
    }
  }
  getIconPath(fileName: string): string {
    return this.attachmentService.getIconPath(fileName);
  }

  downloadScheduleDownload(attachmentId: number) {
    this.onDownload.emit(attachmentId);
  }

  get isScheduleUrl(): boolean {
    this.scheduleUrl = this.row?.airlineBrand?.scheduleUrl;
    if (this.row?.airlineBrand?.scheduleUrl) {
      return true;
    }
  }
  goToAirlineSchedulePage() {
    window.open(this.row?.airlineBrand?.scheduleUrl, '_blank');
  }
  closeModal() {
    this.activeModal.dismiss();
  }

  get isFilesPresent(): boolean {
    return this.files && this.files.length > 0; // Check if the files array exists and has elements
  }
  getFileName(fileName: string): string {
    return fileName.substring(0, fileName.lastIndexOf('.'));
  }
}
